import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// HTTP 410 Gone equivalent for SPA:
// - Injects <meta name="robots" content="noindex,nofollow"> so Google removes the URL
// - Sends a 410 signal to our backend (used by monitoring / logs)
// - Shows a clear "410 Gone" message
// - Does NOT redirect to home (per SEO spec)
export default function Gone({ resource = "This page" }) {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "410 Gone · Documatch";

    // Ensure noindex,nofollow
    let robots = document.querySelector('meta[name="robots"]');
    const created = !robots;
    if (!robots) {
      robots = document.createElement("meta");
      robots.name = "robots";
      document.head.appendChild(robots);
    }
    const prev = robots.getAttribute("content");
    robots.setAttribute("content", "noindex,nofollow,noarchive");

    // Fire-and-forget 410 signal to backend for observability
    try {
      const API = process.env.REACT_APP_BACKEND_URL;
      fetch(`${API}/api/gone-hit`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ path: window.location.pathname, referrer: document.referrer })
      }).catch(() => {});
    } catch (e) { /* ignore */ }

    return () => {
      if (created) document.head.removeChild(robots);
      else if (prev !== null) robots.setAttribute("content", prev);
    };
  }, []);

  return (
    <div className="min-h-screen bg-slate-900 text-white flex items-center justify-center px-4" data-testid="gone-page">
      <div className="max-w-lg text-center">
        <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-red-300 mb-3">HTTP 410 · Gone</p>
        <h1 className="font-playfair text-3xl sm:text-4xl font-bold mb-4">This page no longer exists</h1>
        <p className="text-slate-300 mb-8 leading-relaxed">
          {resource} has been permanently removed and will not return. It is safe for search engines to de-index this URL.
        </p>
        <button
          onClick={() => navigate("/")}
          className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-xl transition-colors"
          data-testid="gone-back-home"
        >
          Back to Documatch
        </button>
      </div>
    </div>
  );
}
